import { useRouterState } from "@tanstack/react-router";

import Carousel from "@/components/carousel";

import type { RelatedCityType } from "../types";
import CityCard from "./city-card";

interface RelatedCitiesProps {
  ariaLabels?: string[];
  children?: React.ReactNode;
  cities: RelatedCityType[];
  count?: number;
  title?: string;
}

export default function RelatedCities({
  ariaLabels,
  children,
  cities,
  count,
  title = "More Escape Rooms",
}: RelatedCitiesProps) {
  const asPath = useRouterState({ select: (s) => s.location.href });

  return (
    <section className="w-full overflow-hidden pt-[55px] md:pt-35">
      <h3 className="mx-auto mb-10 max-w-[325px] text-center font-semibold text-32 text-white leading-[1.25em] md:mb-20 md:max-w-none md:text-48">
        {title}
      </h3>
      <Carousel
        ariaLabels={
          ariaLabels || cities.map((city) => city.attributes.nameShort)
        }
        dataLength={typeof count === "undefined" ? cities.length : count}
        key={asPath}
      >
        {cities.map((city) => (
          <CityCard city={city} key={city.id} />
        ))}
        {children}
      </Carousel>
    </section>
  );
}
